export default __webpack_public_path__ + "static/media/person_coin.0da4eb7b.svg";